module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.91533bcf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-light-webfont.woff2
// module id = 267
// module chunks = 0